import AmpliObrasLink from "./AmpliObrasLink";

export const LockedCell = () => <span className="director-dashboard-locked">Informe as unidades a vender</span>;

export const Note = ({ children, tone }) => <small className="director-dashboard-note" data-tone={tone}>{children}</small>;

// Nome da obra; vira link para o Ampli Obras (nova guia) quando há id.
export const ObraName = ({ name, wbsBuildingId }) => {
  const label = <span className="director-dashboard-cell__name">{name}</span>;
  if (!wbsBuildingId) return label;
  return <AmpliObrasLink className="director-dashboard-cell__anchor" wbsBuildingId={wbsBuildingId}>{label}</AmpliObrasLink>;
};
